import React, { useState } from 'react'
import { IoLogoInstagram } from 'react-icons/io';
import { TbBrandFacebook, TbBrandInstagram, TbBrandWhatsapp } from 'react-icons/tb';
import Logo from '../../assets/logo.png'; // Adjust the path as necessary
import Logo1 from '../../assets/VESHH-EON TYPE.png';
import Marquee from '../../components/Layout/marquee.jsx';
import Marquee2 from '../../components/Layout/marquee2.jsx';


const Footer = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleNewsletterSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setMessage('');

  try {
    const res = await fetch('/api/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (!res.ok) {
      setMessage(data.message || 'Something went wrong.');
      setMessageType('error');
    } else {
      setMessage(data.message);
      setMessageType('success');
      setEmail('');
    }
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    setMessage('Network error. Please try again.');
    setMessageType('error');
  } finally {
    setIsLoading(false);
  }
};

  return (
    <footer className="border-t mt-10 bg-black">
      {/* <Marquee /> */}
      <Marquee direction="left" />

      <div className="relative py-8">

        <div className="festival-garland festival-garland--footer" aria-hidden="true" />
        
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-5 gap-8 px-4 lg:px-0">
          {/* Logo */}
          <div className="flex flex-col items-start w-full  ">
            {/* <img src="https://res.cloudinary.com/dmrlotfsv/image/upload/v1754071341/VESHH-EON_TYPE_WEB_ppfyxy.png" className=" py-10 px-5 w-full"  /> */}
           

            {/* Logo Glitch Video */}
<video 
  src="https://res.cloudinary.com/pizwqtnj/video/upload/w_640,c_limit,f_auto,q_auto/v1792554537/LOGO_GLITCH_EFFECT.mp4" 
  autoPlay 
  muted 
  loop 
  playsInline
  preload="metadata"
  loading="lazy"
  controlsList="nodownload"
  disablePictureInPicture
  onContextMenu={(e) => e.preventDefault()}
  style={{ pointerEvents: 'none' }}
/> 



              
              
            
          </div>
           {/* <Marquee2 /> */}
          <div className="md:hidden">
          <Marquee direction="right" />
          </div>

          <div>
            <h3 className="text-lg text-white mb-2">Newsletter</h3>
            <p className="text-gray-500 mb-4">
              Be the first to know about new Arrivals, Sales, And Special Offers.
            </p>
            {/* <p className="font-medium text-sm text-gray-800 mb-2"> */}
            <p className="font-medium text-sm text-white mb-2">
              Sign-up and get 10% off your first order.
            </p>

            {/* Newsletter form */}
            <form className="flex items-center mb-2" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border border-white bg-black hover:bg-gray-700 rounded-l px-4 py-2 w-full"
                required
                disabled={isLoading}
              />
              <button
                type="submit"
                disabled={isLoading}
                className="border border-white bg-black text-white px-4 py-2 rounded-r hover:bg-gray-700 disabled:opacity-50">
                {isLoading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            
            {/* Message display */}
            {message && (
              <p className={`text-sm mt-2 ${
                messageType === 'success' ? 'text-green-600' : 'text-red-600'
              }`}>
                {message}
              </p>
            )}
          </div>

          {/* Shop Links gray-800*/}
          <div>
            <h3 className="text-lg text-white mb-2">Shop</h3>
            <ul className="text-gray-500 space-y-2">
              <li><a href="/collections/all" className="hover:text-gray-800">New Launches</a></li>
              <li><a href="/collections/Tie Dye Oversized T-Shirt" className="hover:text-gray-800">Tie Dye Oversized T-Shirt</a></li> 
              <li><a href="/collections/Acid Washed Oversized T-Shirt" className="hover:text-gray-800">Acid Washed Oversized T-Shirt</a></li>
              <li><a href="/collections/SweatShirt" className="hover:text-gray-800">SweatShirt</a></li>
              <li><a href="/collections/Oversized SweatShirt" className="hover:text-gray-800">Oversized SweatShirt</a></li>
              <li><a href="/collections/Hoodie" className="hover:text-gray-800">Hoodie</a></li>
              <li><a href="/collections/Oversized Hoodie" className="hover:text-gray-800">Oversized Hoodie</a></li>
              <li><a href="/collections/Acid Washed Hoodie" className="hover:text-gray-800">Acid Washed Hoodie</a></li>
{/*               <li><a href="/products" className="hover:text-gray-800">T-Shirts</a></li>
              <li><a href="/products" className="hover:text-gray-800">Hoodies</a></li> */}
            </ul> 
          </div>

          {/* Support Links gray-800*/}
          <div>
            <h3 className="text-lg text-white mb-2">Support</h3>
            <ul className="text-gray-500 space-y-2">
              <li><a href="/contact" className="hover:text-gray-800">Contact Us</a></li>
              <li><a href="/about" className="hover:text-gray-800">About Us</a></li> 
{/*               <li><a href="/products" className="hover:text-gray-800">FAQs</a></li> */}
              <li><a href="https://veshh-eon-creator-program.vercel.app/" className="hover:text-gray-800">Collaborations</a></li>

              <li><a href="/returnpolicy" className="hover:text-gray-800">Return Policy</a></li>
              <li><a href="/return" className="hover:text-gray-800">Return</a></li>
              <li><a href="/terms" className="hover:text-gray-800">Terms And Condition</a></li>
              <li><a href="/shipping" className="hover:text-gray-800">Shipping</a></li>
              
            </ul> 
          </div>

          {/* Follow Us gray-800*/}
          <div>
            <h3 className="text-lg text-white mb-2">Follow Us</h3>
            <div className="flex items-center space-x-4 mb-2"> 
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-800">
                <IoLogoInstagram className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-800">
                <TbBrandFacebook className="h-5 w-5"/>
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-800">
                <TbBrandWhatsapp className="h-5 w-5" />
              </a>
            </div>
            <h3 className="text-lg text-white mb-2">Experience VESHH-EON App</h3>
            <a 
    href="https://play.google.com/store/apps/details?id=com.veshheon.app" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <img 
      src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/GetItOnGooglePlay_Badge_Web_color_English_bqymql"
      alt="Get it on Google Play"
      className="h-10 w-auto hover:opacity-80 transition"
    />
  </a>
            
          </div>
        </div>
      </div>
      {/* gray-500 */}
      <p className="container text-white text-sm tracking-tighter text-center mx-auto pb-1 px-4 lg:px-0 bordet-t border-gray-200 pt-6">
        © {new Date().getFullYear()} VESHH-EON. All rights reserved.
      </p>
        <div className="festival-ground" aria-hidden="true" />
    </footer>
  );
};

export default Footer;
